module.exports = __webpack_public_path__ + "static/media/campaign.2a2dc694.svg";